import React from "react";
import MainFeaturedPost from "../../components/ImageComponent/MainFeaturedPost";
import image from "../../images/hero_support.jpg";
import SolutionsLayout from "../../layouts/SolutionsLayout";
import { Box, Container } from "@material-ui/core";
import ProductsList from "../../components/ProductsList";
import HeroContent from "../../components/HeroContent";
import HeroText from "../../components/HeroContent/heroText";
import { consultData, supportData } from "../../data/support";
import endImage from "../../images/support/support-end-hero.jpg";

const SupportServicesPage = () => {
	return (
		<SolutionsLayout title="Unity Support - Help and advice for all Unity users | Customer Success ">
			<MainFeaturedPost
				post={{
					title: "Support and Services",
					description: `Welcome to Unity Support and Services. Our mission is to provide you with best-in-class expertise and support so you can get the help you need to succeed, when you need it.`,
					image: image,
					imgText: "main image description",
				}}
			/>

			<Container style={{ paddingTop: "64px", paddingBottom: "64px" }}>
				<HeroContent
					fileName="support/support-hero-image.webp"
					heroTitle="Customer Service"
					heroContent="Get assistance with non-technical issues like account activations, Hub errors, account management, billing, the Asset Store and more. For self-help resources, see our Knowledge Base."
					altText="Customer Service"
				/>
			</Container>
			<Box
				width="100%"
				style={{ backgroundColor: "#ededed", paddingBottom: "64px" }}
			>
				<Container>
					<HeroText
						heroTitle="Technical Support"
						heroContent="For technical issues of all complexities, Unity offers a variety of free and fee-based premium support options to our users at any stage of their project."
					/>
					<ProductsList md={4} data={supportData} elevation={2} />
				</Container>
			</Box>
			<Container>
				<HeroText
					heroTitle="Consulting Services"
					heroContent="From a simple consultation to a complete development effort, get the expertise you need to take your project to the next level."
				/>
				<ProductsList data={consultData} md={6}
                elevation={2} />
			</Container>
			<Container style={{ paddingTop: "64px", paddingBottom: "64px" }}>
				<HeroContent
					fileName="support/pro-training.jpg"
					heroTitle="Professional Training"
					heroContent="Enhance your team’s skills, increase productivity, and improve workflows with training courses led by Unity Certified Instructors, designed for professionals in any industry. Choose from live public sessions, private training, or our on-demand platform."
				/>
			</Container>
			<Container>
				<MainFeaturedPost
					post={{
						title: "Get Answers",
						description: `Still can't find what you're looking for?`,
						image: endImage,
						imgText: "Get Answers",
						buttonText: "Contact Us",
					}}
				/>
			</Container>
		</SolutionsLayout>
	);
};

export default SupportServicesPage;
